import { Route, Redirect, useLocation } from "react-router-dom";
import React, { Suspense, lazy, Fragment, useState, useEffect, useLayoutEffect } from "react";
import Loader from "react-loaders";
import { ToastContainer } from "react-toastify";
import AppHeader from "../AppHeader";
import AppSidebar from "../AppSidebar";
import records from "../../Services/records";
import util from "../../Utils/util";
import { appContext } from "../../Utils/context";

const Records = lazy(() => import("../../DemoPages/Records"));
const ManageStatus = lazy(() => import("../../DemoPages/ManageStatus"));
const FileUpload = lazy(() => import("../../DemoPages/FileUpload"));
const RolesManagemet = lazy(() => import("../../DemoPages/RolesManagement"));
const Dashboard = lazy(() => import("../../DemoPages/Dashboard"));
const CustomerCare = lazy(() => import("../../DemoPages/CustomerCare"));
const Cart = lazy(() => import("../../DemoPages/Cart"))
const LeadsCreation = lazy(() => import("../../DemoPages/LeadsCreation"))
const ListCreation = lazy(() => import("../../DemoPages/ListCreation"))
const SkipTracing = lazy(() => import("../../DemoPages/SkipTracing"))
const LeadsScrubber = lazy(() => import("../../DemoPages/LeadsScrubber"))
const PartnershipPortal = lazy(() => import("../../DemoPages/PartnershipPortal"))
const Profile = lazy(() => import("../../DemoPages/Profile"))
const AffiliateSystem = lazy(() => import("../../DemoPages/AffiliateSystem"))
const Gpt = lazy(() => import("../../DemoPages/Gpt"))
const Marketing = lazy(() => import("../../DemoPages/Marketing"))




const AppMain = () => {
    const [groupOptions, setGroupOptions] = useState([])
    const [data, setData] = useState([])
    const [user, setUser] = useState({})
    const [errorMsg, setErrorMsg] = useState("")
    const [show, setShow] = useState(false)
    const [myLists, setMyLists] = useState([])
    const [breadItems, setBreadItems] = useState([])
    const [userWizard, setUserWizard] = useState(false)
    const [wizardBackdrop, setWizardBackdrop] = useState('static')
    const [addressId, setAddressId] = useState("")
    const [tagsData, setTagsData] = useState({})
    const [notesData, setNotesData] = useState([])
    const [tasksData, setTasksData] = useState([])
    const [manualAdd, setManualAdd] = useState({})
    const [view, setView] = useState('list')

    const location = useLocation()
    const token = new URLSearchParams(location.search).get('token')

    useLayoutEffect(() => {
        if (token !== null && token !== undefined) {
            util.setToken(token)
        }

    }, [token])

    useEffect(() => {

        let title = location?.pathname.replace(/[/-]+/g, ' ')
        document.title = title.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        let items = location?.pathname.replace(/[/]+/g, ' ').split(' ').slice(1)
        setBreadItems(items)
        records.getUserProfile().then((res) => {
            //  console.log('user profile', res?.data)
            setUser(res?.data);
            if (
                !res?.data?.phone ||
                !res?.data?.email ||
                !res?.data?.address ||
                !res?.data?.city ||
                !res?.data?.state ||
                !res?.data?.zip ||
                !res?.data?.state_and_counties
            ) {
                setUserWizard(true)
                setWizardBackdrop('static')
            }


            if (res?.data?.is_staff) {
                util.setIsStaff("staff")
            }
            else {
                util.setIsStaff("noStaff")
            }
        }).catch((err) => {
            console.log("Error Is", err)

            if (err?.response?.data?.msg) {
                setErrorMsg(err?.response?.data?.msg)
            }
            if (err?.response?.data?.detail) {
                setErrorMsg(err?.response?.data?.detail)
            }

            setShow(true)
        })
    }, [location])

    const toggleUserWizard = () => {
        setUserWizard(!userWizard)
    }

    return (
        <Fragment>
            <appContext.Provider value={{
                view, setView, addressId, setAddressId, setTagsData, tagsData, setNotesData, notesData, setTasksData, tasksData, setManualAdd, manualAdd,
                groupOptions, setGroupOptions, data, setData, user, setUser,
                myLists, setMyLists, userWizard, toggleUserWizard, wizardBackdrop, setWizardBackdrop
            }}>
                <AppHeader items={breadItems} errorMsg={errorMsg} show={show} />
                <div className="app-background"></div>
                <div className="app-main" style={{ background:'#f1f4f6'}}>
                    <AppSidebar />
                    <div className="app-main__outer ">
                        <div className="app-main__inner">

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>

                            }>
                                <Route path="/records" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <Records />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/records")
                                    )
                                )} />
                            </Suspense>

                            {/* Settings */}

                            <Suspense fallback={
                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/settings" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <ManageStatus />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/settings")
                                    )
                                )} />
                            </Suspense>

                            {/* File Upload */}

                            <Suspense fallback={
                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/upload-file" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <FileUpload />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm//upload-file")
                                    )
                                )} />
                            </Suspense>

                            {/* Roles Management */}

                            <Suspense fallback={
                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/roles-management" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <RolesManagemet />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/roles-management")
                                    )
                                )} />
                            </Suspense>

                            {/* Dashboard */}

                            <Suspense fallback={
                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/dashboard" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <Dashboard />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/dashboard")
                                    )
                                )} />
                            </Suspense>

                            {/* Customer Care */}

                            <Suspense fallback={
                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/customer-care" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <CustomerCare />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/customer-care")
                                    )
                                )} />
                            </Suspense>

                            {/* Cart */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/cart" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <Cart />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/cart")
                                    )
                                )} />
                            </Suspense>

                            {/* Leads Creation */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/leads" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <LeadsCreation />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/leads")
                                    )
                                )} />
                            </Suspense>

                            {/* Lists Creation */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/lists" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <ListCreation />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/lists")
                                    )
                                )} />
                            </Suspense>

                            {/* Marketing */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                                }>
                                <Route path="/marketing" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <Marketing />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/lists")
                                    )
                                )} />
                                </Suspense>

                            {/* Skip Tracing */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/skipTrace" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <SkipTracing />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/skipTrace")
                                    )
                                )} />
                            </Suspense>


                            {/* Leads Scrubber */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/scrubbing-system/upload-file/" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <LeadsScrubber />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/scrubbing-system/upload-file/")
                                    )
                                )} />
                            </Suspense>

                            {/* Partnership Portal */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/partnership-portal" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <PartnershipPortal />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/partnership-portal/")
                                    )
                                )} />
                            </Suspense>

                            {/* Profile */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/profile" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <Profile />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/profile/")
                                    )
                                )} />
                            </Suspense>

                            {/* Affiliate Systems */}

                            <Suspense fallback={

                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                            }>
                                <Route path="/affiliate-systems" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <AffiliateSystem />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/affiliate-systems/")
                                    )
                                )} />
                            </Suspense>

                            {/* ChatGpt */}

                            <Suspense fallback={
                                <div className="text-center d-flex justify-content-center align-items-center h-100">
                                    <Loader type="ball-clip-rotate-multiple" style={{ transform: 'scale(1.3)' }} />
                                </div>
                                }>
                                <Route path="/chat-gpt" render={() => (
                                    (util.isLogged() || token != null) ? (
                                        <Gpt />
                                    ) : (
                                        window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/profile/")
                                    )
                                )} />
                                </Suspense>

                            <Route exact path="/" render={() => (
                                util.isLogged() ? (
                                    <Redirect to="/dashboard" />
                                ) : (
                                    window.location.replace("https://leadfuzionlists.com/login?next=/crm_apis/v1/redirect/crm/dashboard")
                                )
                            )} />


                        </div>
                        <div className="app-wrapper-footer">

                        </div>
                    </div>
                </div>
            </appContext.Provider>
            <ToastContainer />
        </Fragment>
    )
};

export default AppMain;
